import { render } from "./deploy.vue?vue&type=template&id=0609ec7a"
import script from "./deploy.vue?vue&type=script&lang=ts"
export * from "./deploy.vue?vue&type=script&lang=ts"

import "./deploy.vue?vue&type=style&index=0&id=0609ec7a&lang=css"
script.render = render

export default script